import React, { Component,Suspense, lazy } from 'react';
import { Switch, Route, Redirect, withRouter } from 'react-router-dom';

import Spinner from '../app/shared/Spinner';

const Dashboard = lazy(() => import('./dashboard/Dashboard'));



const Buttons         = lazy(() => import('./basic-ui/Buttons'));
const Dropdowns       = lazy(() => import('./basic-ui/Dropdowns'));
const Typography      = lazy(() => import('./basic-ui/Typography'));
const BasicElements   = lazy(() => import('./form-elements/BasicElements'));
const BasicTable      = lazy(() => import('./tables/BasicTable'));
const Mdi             = lazy(() => import('./icons/Mdi'));
const ChartJs         = lazy(() => import('./charts/ChartJs'));
const Error404        = lazy(() => import('./error-pages/Error404'));
const Error500        = lazy(() => import('./error-pages/Error500'));
const Login           = lazy(() => import('./user-pages/Login_new'));
const Register1       = lazy(() => import('./user-pages/Register_new'));
const Lockscreen      = lazy(() => import('./user-pages/Lockscreen'));
const People          = lazy(() => import('./user-pages/People'));
const Handbook        = lazy(() => import('./user-pages/Handbook'));
const ReportForm      = lazy(() => import('./user-pages/ReportForm'));
const BlankPage       = lazy(() => import('./general-pages/BlankPage'));
const SalesReport     = lazy(() => import('./user-pages/SalesReport'));
const AfterSaleReport = lazy(() => import('./user-pages/AfterSaleReport'));
const ConSalesReport  = lazy(() => import('./user-pages/ConSalesReport'));
const TechnicalReport = lazy(() => import('./user-pages/TechnicalReport'));
const IncidentReport  = lazy(() => import('./user-pages/IncidentReport'));
const EngineerReport  = lazy(() => import('./user-pages/EngineerReport'));
const EditProfile     = lazy(() => import('./user-pages/EditProfile'));
const StaffList       = lazy(() => import('./user-pages/StaffList'));
const ImageCropper    = lazy(() => import('./user-pages/ImageCropper'));
const AdminRight      = lazy(() => import('./user-pages/AdminRight'));
const ForgotPass      = lazy(() => import('./user-pages/ForgotPass'));
const Report          = lazy(() => import('./user-pages/Report'));
//const Login     = lazy(()=>import('./authentication/Login'));




class AppRoutes extends Component {
  render () {
    const { history } = this.props;
    // Check if the current path is "/user-pages/register-1"
    const isRegisterPage = history.location.pathname === '/user-pages/register-1';


    return (
      <Suspense fallback={<Spinner/>}>
        <Switch>
          <Route exact path="/dashboard" component={ People } />


          <Route path="/basic-ui/buttons" component={ Buttons } />
          <Route path="/basic-ui/dropdowns" component={ Dropdowns } />
          <Route path="/basic-ui/typography" component={ Typography } />


          <Route path="/form-Elements/basic-elements" component={ BasicElements } />

          <Route path="/tables/basic-table" component={ BasicTable } />


          <Route path="/icons/mdi" component={ Mdi } />


          <Route path="/charts/chart-js" component={ ChartJs } />


          <Route path="/user-pages/login-1" component={ Login } />
          <Route path="/user-pages/register-1" component={ Register1 } />
          <Route path="/user-pages/lockscreen" component={ Lockscreen } />
          <Route path="/user-pages/people" component={ People } />
          <Route path="/user-pages/handbook" component={ Handbook } />
          <Route path="/user-pages/reportform" component={ ReportForm } />
          <Route path="/user-pages/salesreport" component={ SalesReport } />
          <Route path="/user-pages/aftersalereport" component={ AfterSaleReport } />
          <Route path="/user-pages/consalesreport" component={ ConSalesReport } />
          <Route path="/user-pages/techreport" component={ TechnicalReport } />
          <Route path="/user-pages/incidentreport" component={ IncidentReport } />
          <Route path="/user-pages/engineerreport" component={ EngineerReport } />
          <Route path="/user-pages/editprofile" component={ EditProfile } />
          <Route path="/user-pages/stafflist" component={ StaffList } />
          <Route path="/user-pages/imagecropper" component={ ImageCropper } />
          <Route path="/user-pages/adminright" component={ AdminRight } />
          <Route path="/user-pages/forgotpass" component={ ForgotPass } />
          <Route path="/user-pages/report" component={ Report } />

          <Route path="/error-pages/error-404" component={ Error404 } />
          <Route path="/error-pages/error-500" component={ Error500 } />

          <Route path="/general-pages/blank-page" component={ BlankPage } />


          {!isRegisterPage && <Redirect to="/user-pages/login-1" />}
        </Switch>
      </Suspense>
    );
  }
}

export default withRouter(AppRoutes);